import React, { Component } from 'react';
import Toggle from 'react-toggle';
import classnames from 'classnames';
import { ENTER_KEY_NAME } from '@mm/constants/keys-codes';
import './imageUploadFormModal.scss';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../modals/modal-helpers';
import Button from '../../../buttons/DeprecatedButton/DeprecatedButton';

type Props = {
  showModal: boolean;
  onNextButtonClick: (isImageSquare: boolean) => void;
  onCancelButtonClick: () => void;
  isToggleChecked: boolean;
  closeModal: () => void;
};

export default class ImageUploadFormModal extends Component<
  Props,
  { isImageSquare: boolean }
> {
  constructor(props) {
    super(props);
    this.state = {
      isImageSquare: false,
    };
  }

  static defaultProps = {
    showModal: false,
    isToggleChecked: false,
    onNextButtonClick: () => {},
    onCancelButtonClick: () => {},
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onImageUploadKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onImageUploadKeyDown);
  }

  onImageUploadKeyDown = e => {
    if (e.key === ENTER_KEY_NAME) {
      this.onNextButtonClick();
      e.preventDefault();
    }
  };

  onToggleChange = () => {
    this.setState(state => ({ isImageSquare: !state.isImageSquare }));
  };

  onNextButtonClick = () => {
    const { isImageSquare } = this.state;
    this.props.onNextButtonClick(isImageSquare);
    this.props.closeModal();
  };

  onCancelClick = () => {
    this.props.onCancelButtonClick();
    this.props.closeModal();
  };

  render() {
    const { isToggleChecked } = this.props;
    const { isImageSquare } = this.state;
    const rectangularClassName = classnames(
      'image-upload-form-modal__toggle-label',
      {
        'image-upload-form-modal__toggle-label--selected': !isImageSquare,
      },
    );
    const squareClassName = classnames(
      'image-upload-form-modal__toggle-label',
      {
        'image-upload-form-modal__toggle-label--selected': isImageSquare,
      },
    );
    return (
      <div className="image-upload-form-modal">
        <ModalHeader
          className="create-chatbot-modal__header-container"
          closeOverride={this.onCancelClick}
        >
          <h2>Configure image proportion for this gallery</h2>
        </ModalHeader>

        <ModalBody>
          <div className="image-upload-form-modal__description">
            The setting you pick will apply to all images in this gallery and
            you will not be able to change it later.
          </div>
          <div className="image-upload-form-modal__toggle-container">
            <span className={rectangularClassName}>rectangular</span>
            <Toggle
              defaultChecked={isToggleChecked}
              checked={isImageSquare}
              icons={false}
              onChange={this.onToggleChange}
            />
            <span className={squareClassName}>square</span>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.onCancelClick} red>
            Cancel
          </Button>
          <Button onClick={this.onNextButtonClick}>Next</Button>
        </ModalFooter>
      </div>
    );
  }
}
